import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PitchPlaylistMusicService } from '../../external-pitch/pitch-playlist-music-service';
import { PitchSongsApiService } from '../../external-pitch/pitch-song-api.service';
import { SONG_API_SERVICE } from '../../../../../../src/app/song/types';
import { WmgSongsApiService } from 'src/app/shared/services/wmg-song-api.service';
import { PLAYLIST_MUSIC_SERVICE } from 'src/app/player/interfaces';

@NgModule({
  imports: [CommonModule],
  exports: [CommonModule],
  declarations: []
})
export class PitchServicesModule {
  static forRoot(): ModuleWithProviders<PitchServicesModule> {
    return {
      ngModule: PitchServicesModule,
      providers: [
        PitchSongsApiService,
        {
          provide: SONG_API_SERVICE,
          useExisting: PitchSongsApiService
        },
        {
          provide: WmgSongsApiService,
          useExisting: PitchSongsApiService
        },
        {
          provide: PLAYLIST_MUSIC_SERVICE,
          useClass: PitchPlaylistMusicService
        }
      ]
    };
  }
}
